import { getContactFields } from "config/candidateFields";
import { useCandidateSectionContext } from "../../../hooks/useCandidateSectionContext";
import { CandidateFieldsSection } from "../candidateFieldsSection";

export const ContactDetails = ({
  candidateJobEntry,
  setCandidateJobEntry,
  onCandidateChanged,
  isAssignedToJob,
}) => {
  const { baseContext } = useCandidateSectionContext(
    candidateJobEntry,
    setCandidateJobEntry,
    onCandidateChanged,
    isAssignedToJob,
  );

  return (
    <CandidateFieldsSection
      title="Contact Details"
      fields={getContactFields()}
      context={baseContext}
    />
  );
};
